// Upstream: markmead/hyperui public/examples/application/details-list/1-dark.html — MIT (dl/dt/dd details list).

import type { ComponentProps } from "react";
import { cn } from "@/lib/cn";

/** Key/value grid: term column + value column from 640px, stacked pairs below. */
export function DescriptionList({ className, ...rest }: ComponentProps<"dl">) {
  return (
    <dl
      data-slot="description-list"
      className={cn(
        "grid grid-cols-1 gap-x-6 sm:grid-cols-[minmax(0,12rem)_minmax(0,1fr)] sm:gap-y-3",
        className,
      )}
      {...rest}
    />
  );
}

export function DescriptionTerm({ className, ...rest }: ComponentProps<"dt">) {
  return (
    <dt
      data-slot="description-term"
      className={cn("mt-3 text-sm text-fg-2 first:mt-0 sm:mt-0", className)}
      {...rest}
    />
  );
}

export function DescriptionDetails({ className, ...rest }: ComponentProps<"dd">) {
  return (
    <dd data-slot="description-details" className={cn("min-w-0 break-words text-fg-0", className)} {...rest} />
  );
}
